"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIScanPlanRequestSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
// ===== SCHEMAS =====
exports.APIScanPlanRequestSchema = zod_1.z.object({
    numScans: zod_1.z.number().min(1).nullish(),
    minScans: zod_1.z.number().min(1).nullish(),
    effortLevel: zod_1.z.enum(enums_1.effortLevelEnum).nullish(),
    budgetLevel: zod_1.z.enum(enums_1.budgetLevelEnum).nullish(),
});
//# sourceMappingURL=scan_plan.js.map